import Badge from "ds/components/Badge";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

const IntegrationsAiTableStatusCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AiIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {item.enabled ? (
        <Badge type="strong" variant="green" text="Enabled" />
      ) : (
        <Badge type="strong" variant="gray" text="Disabled" />
      )}
    </TableSimpleCell>
  );
};

export default IntegrationsAiTableStatusCell;
